import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { appConfig } from 'app/core/config/app.config';
import { AuthCoreModule } from 'app/core/auth/auth-core.module';
import { AuthBootstrapService } from 'app/core/auth/services/auth-bootstrap.service';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ToastrModule } from 'ngx-toastr';
import { AuthModule } from './modules/auth/auth.module';
import { RoleBasedPreloader } from './role-based.preloading';
import { NgEventBus } from 'ng-event-bus';

const routerConfig: ExtraOptions = {
    preloadingStrategy: RoleBasedPreloader,
    scrollPositionRestoration: 'disabled',
    onSameUrlNavigation: 'ignore',
};

function initializeAuth(authBootstrap: AuthBootstrapService): () => Promise<boolean> {
    return () => authBootstrap.initialize();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        AuthCoreModule,

        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        LoggerModule.forRoot({
            level: NgxLoggerLevel.DEBUG,
        }),

        ToastrModule.forRoot({
            closeButton: true,
        }),

        CoreModule,
        AuthModule,
        LayoutModule,
    ],
    bootstrap: [AppComponent],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAuth,
            deps: [AuthBootstrapService],
            multi: true,
        },
        NgEventBus,
    ],
})
export class AppModule {}
